import shajs from "sha.js"

export class EmailAddress {
  readonly value: string

  constructor(value: string) {
    this.value = value
  }

  hashed = (): string => shajs(`sha256`).update(this.value).digest(`hex`)
}

export class Customer {
  readonly id: string | number
  readonly email: EmailAddress

  constructor(id: string | number, email: EmailAddress) {
    this.id = id
    this.email = email
  }
}

export class Guest {
  readonly email: EmailAddress

  constructor(email: EmailAddress) {
    this.email = email
  }
}

export type Visitor = Customer | Guest
